import React, { useContext, useState } from 'react';
import { TextField, MenuItem, Button, Box, FormControlLabel, FormGroup, FormControl, Checkbox, Backdrop, CircularProgress } from '@mui/material';
import { API } from '../conf';
import { Context } from '../App';

export default function AlerteForm(props) {
    const {updateConnect} = useContext(Context)
    const [load, setLoad] = useState(false);
    const [title, setTitle] = useState(props.alert?.title || '');
    const [message, setMessage] = useState(props.alert?.message || '');
    const [level, setLevel] = useState(props.alert?.level || 1);
    const [model, setModel] = useState(props.alert?.model || '');
    const [objectKey, setObjectKey] = useState(props.alert?.object_key?? []);
    const [isActive, setIsActive] = useState(props.alert?.is_active?? true);
    const [startTime, setStartTime] = useState(new Date(props.alert?.start_time || Date.now()));
    const [endTime, setEndTime] = useState(props.alert?.end_time ? new Date(props.alert.end_time): null);
    const [eglises, setEglises] = useState(props.alert?.eglises || []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoad(true)
        const alertData = {
            title,
            message,
            level,
            model,
            object_key: objectKey,
            is_active: isActive,
            start_time: startTime,
            end_time: endTime,
            eglises,
        };
        fetch(API.concat(props.edit ? `/alerts/${props.alert?._id}` :'/alert'), {method:props.edit? 'PATCH' :'POST', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }, body:JSON.stringify(alertData)}).then(async(response) => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const {alert, user} = await response.json()
                    alert.autor = user
                    props.add(alert); 
                    props.close()
                }
            }
        })
    };

    const handleTitleChange = (e) => {
        const value = e.target.value;
        if (value.length <= 100) {
            setTitle(value);
        }
    };

    const handleEglisesChange = (e) => {
        setEglises(
            eglises.includes(e)
                ? eglises.filter((id) => id !== e)
                : [...eglises, e]
        );
    };

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,padding: 2,
            }}
        >
            <TextField
                label="Titre"
                variant="outlined"
                value={title}
                onChange={handleTitleChange}
                required
                fullWidth
                helperText={`${title.length}/100`}
            />
            <TextField
                label="Message"
                variant="outlined"
                required
                multiline
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                fullWidth
            />
            <TextField
                select
                label="Niveau"
                required
                value={level}
                onChange={(e) => setLevel(Number(e.target.value))}
                fullWidth
            >
                <MenuItem value={1}>Info</MenuItem>
                <MenuItem value={2}>Warning</MenuItem>
                <MenuItem value={3}>Erreur</MenuItem>
            </TextField>
            <TextField
                select
                label="Modèle"
                value={model}
                onChange={(e) => setModel(e.target.value)}
                fullWidth
            >
                <MenuItem value="Don">Don</MenuItem>
                <MenuItem value="Depense">Depense</MenuItem>
                <MenuItem value="Versement">Versement</MenuItem>
                <MenuItem value="">Aucun</MenuItem>
            </TextField>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                    />
                }
                label="Activée"
            />
            <TextField
                label="Date de début"
                type="datetime-local"
                value={startTime.toISOString().slice(0, 16)}
                onChange={(e) => setStartTime(new Date(e.target.value))}
                fullWidth
            />
            <TextField
                label="Date de fin"
                type="datetime-local"
                InputLabelProps={{ shrink: true }}
                value={endTime ? endTime.toISOString().slice(0, 16) : ''}
                onChange={(e) => setEndTime(e.target.value ? new Date(e.target.value) : null)}
                fullWidth
            />
            <Button onClick={()=> setEglises(eglises.length===props.eglises.length? [] : props.eglises.map(eglise => eglise.number))} variant="clear" color="primary">
                {eglises.length===props.eglises.length?'Déselectionner' : 'Tout sélectionner'}
            </Button>
            <FormControl component="fieldset">
                <FormGroup>
                    {props.eglises?.map((eglise) => (
                        <FormControlLabel
                            key={eglise.number}
                            control={
                                <Checkbox
                                    checked={eglises.includes(eglise.number)}
                                    onChange={() => handleEglisesChange(eglise.number)}
                                />
                            }
                            label={eglise.nom}
                        />
                    ))}
                </FormGroup>
            </FormControl>
            <Button type="submit" variant="contained" color="primary">
                {props.edit? 'Enregistrer les modifications':'Créer Alerte'}
            </Button>
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    );
};
